import { Box } from '@mui/material';
const Layout = ({ children }) => {
  return (
    <Box>{children}</Box>
  )
}
export default Layout;